import axios from 'axios'
import qs from 'qs'
import store from '../store/index.js'
import token_conf from './token_conf.js'

let HOST_LIST = {
    domain: '',
    api: '',
    pc: '',
    channel: '',
    lang: '',
    currency: '',
}
let js_domain = ''
if (process.env.NODE_ENV == 'app' || process.env.NODE_ENV == 'production' || process.env.NODE_ENV == 'sandbox') {
    //js_domain = process.env.API_ROOT
    js_domain = '//api.'+document.domain.split('.').slice(-2).join('.')
}
/*else if (process.env.NODE_ENV == 'production') {
    js_domain = '//www.'+document.domain.split('.').slice(-2).join('.')
}*/
if (process.env.NODE_ENV == 'app' || process.env.NODE_ENV == 'production') {
    HOST_LIST.domain = js_domain + '/'
    HOST_LIST.api = js_domain + '/mobile/'
    HOST_LIST.pc = HOST_LIST.domain
} else {
    HOST_LIST.domain = '/api/'
    HOST_LIST.api = '/api/'
    HOST_LIST.pc = process.env.API_ROOT + '/'
}
//var headers1 = { 'Content-Type': 'application/x-www-form-urlencoded' }
var headers1 = {
    'Content-Type': 'application/x-www-form-urlencoded',
}
var headers2 = {
    'Content-Type': 'multipart/form-data'
}
var config = {
    method: 'post',
    url: "",
    data: '',
    headers: headers1,
}
export function format_url(url) {
    if (url.indexOf('http://') == 0 || url.indexOf('https://') == 0) {
        return url
    }
    if (url.indexOf('/') == 0) {
        url = url.substring(1, 111)
    }
    header_token()
    if (url.indexOf('common/') == -1 && url.indexOf('api/') == -1) {
        return HOST_LIST.api + url
    } else {
        return HOST_LIST.domain + url
    }
}
export function redirect_url(url) {
    if (!url) {
        return HOST_LIST.pc
    }
    if (url.indexOf('http://') == 0 || url.indexOf('https://') == 0) {
        return url
    }
    if (url.indexOf('/') == 0) {
        url = url.substring(1, 111)
    }
    header_token()
    return HOST_LIST.pc + url
}
axios.defaults.withCredentials = true
//var instance = axios.create({});

export function header_token() {
    let token = token_conf.get()
    let tokenchannel = localStorage.getItem('tokenchannel')
    let tokenlang = token_conf.get('tokenlang')
    let tokencurrency = token_conf.get('tokencurrency')
    let tokenguest = token_conf.get('tokenguest')
    let tokenguestaccess = token_conf.get('tokenguestaccess')



    axios.defaults.headers.common['token'] = token ? token : '';
    axios.defaults.headers.common['tokenauth'] = 1;
    axios.defaults.headers.common['tokenchannel'] = tokenchannel ? tokenchannel : HOST_LIST.channel;
    axios.defaults.headers.common['tokenlang'] = tokenlang ? tokenlang : HOST_LIST.lang;
    axios.defaults.headers.common['tokencurrency'] = tokencurrency ? tokencurrency : HOST_LIST.currency;
    axios.defaults.headers.common['tokenguest'] = tokenguest ? tokenguest : '';
    axios.defaults.headers.common['tokenguestaccess'] = tokenguestaccess ? tokenguestaccess : '';


}
export function parames(that, parames = '') {
    if (that._func.isObj(parames)) {
        return decodeURIComponent(qs.stringify(parames))
    } else {
        return parames
    }
}
export function fetch(url, parames = '', that, is_loadding = 1) {
    var promise = new Promise(function(resolve, reject) {
        var tun = ''
        if (that._func.isObj(parames)) {
            config.data = qs.stringify(parames)
        } else {
            config.data = parames
        }
        if (that.$route.query.sys_info) {
            if (config.data) {
                config.data += '&sys_info=' + that.$route.query.sys_info
            } else {
                config.data = 'sys_info=' + that.$route.query.sys_info
            }
        }
        config.headers = headers1
        config.url = format_url(url)
        if (is_loadding) store.commit('G_LOADING', {
            isLoading: true
        })
        axios(config).then(function(res) {
            res = res.data
            if (res.success) {
                if (res.data) {
                    tun = res.data
                } else {
                    tun = -1
                }
            } else {
                if (res.msg) {
                    that.$vux.toast.show({
                        text: res.msg,
                        width: 'auto',
                        type: 'text',
                    })
                }
                if (res.code) {
                    if (res.code == 10) {
                        setTimeout(function() {
                            that.$store.commit('G_USERINFO', {})
                            that.$router.push(`/member/login`)
                        }, 1000)
                    } else if (res.code == 20) {
                        that.$router.push(res.location)
                    } else if (res.code == 90) {
                        that.$store.commit('G_GUESTBOOKING', true)
                    }
                }
            }
            if (is_loadding) that.$store.commit('G_LOADING', {
                isLoading: false
            })
            resolve(tun)
        }).catch(function(error) {
            if (is_loadding) that.$store.commit('G_LOADING', {
                isLoading: false
            })
            that.$vux.toast.show({
                text: error.message,
                type: 'warn'
            })
            reject(tun)
        })
    })
    return promise
}
export function page(url, parames = '', that, is_loadding = 1) {
    var promise = new Promise(function(resolve, reject) {
        var tun = ''
        if (that._func.isObj(parames)) {
            config.data = qs.stringify(parames)
        } else {
            config.data = parames
        }
        config.url = format_url(url)
        config.headers = headers1
        if (is_loadding) store.commit('G_LOADING', {
            isLoading: true
        })
        axios(config).then(function(res) {
            res = res.data
            if (res.success) {
                if (res.data) {
                    tun = {
                        items: res.data.data,
                        exts: {},
                        pages: res.data.pages
                    }
                    if (res.data.exts) {
                        tun.exts = res.data.exts
                    }
                } else {
                    tun = -1
                }
            } else {
                if (res.msg) {
                    that.$vux.toast.show({
                        text: res.msg,
                        width: 'auto',
                        type: 'text',
                    })
                }
                if (res.code) {
                    if (res.code == 10) {
                        setTimeout(function() {
                            that.$store.commit('G_USERINFO', {})
                            that.$router.push(`/member/login`)
                        }, 1000)
                    } else if (res.code == 20) {
                        that.$router.push(res.location)
                    }
                }
            }
            if (is_loadding) that.$store.commit('G_LOADING', {
                isLoading: false
            })
            resolve(tun)
        }).catch(function(error) {
            if (is_loadding) that.$store.commit('G_LOADING', {
                isLoading: false
            })
            that.$vux.toast.show({
                text: error.message,
                type: 'warn'
            })
            reject(tun)
        })
    })
    return promise
}
export function post_form(url, parames = '', that, is_loadding = 1, error_msg = 1, success_msg = 0, rediret = false) {
    var promise = new Promise(function(resolve, reject) {
        var tun = false
        if (that._func.isObj(parames)) {
            config.data = qs.stringify(parames)
        } else {
            config.data = parames
        }
        config.url = format_url(url)
        config.headers = headers1
        if (is_loadding) {
            that.$vux.toast.show({
                text: that._func.loading(that),
                type: 'text',
                time: '200000',
                isShowMask: true
            })
        }
        axios(config).then(function(res) {
            if (is_loadding) that.$vux.toast.hide()
            if (rediret) {
                tun = res.data
            } else {
                res = res.data
                if (res.success) {
                    if (res.token) {
                        token_conf.set('token',res.token)
                        token_conf.del('tokenguest')
                        token_conf.del('tokenguestaccess')
                    }
                    if (res.data) {
                        tun = res.data
                    } else {
                        tun = -1
                    }
                    if (success_msg == 1) {
                        that.$vux.toast.show({
                            text: res.msg,
                            type: 'success',
                        })
                        setTimeout(function() {
                            that.$vux.toast.hide()
                        }, 2000)
                    }
                } else {
                    if (error_msg == 1) {
                        if (res.return_tip) {
                            tun = res
                        } else {
                            that.$vux.toast.show({
                                text: res.msg,
                                width: 'auto',
                                type: 'text',
                                onShow() {
                                    if (res.data && res.data.go_redirect) {
                                        setTimeout(function() {
                                            that.$router.push(res.data.go_redirect)
                                        }, 1000)
                                    }
                                }
                            })
                            setTimeout(function() {
                                that.$vux.toast.hide()
                            }, 2000)
                        }
                    }
                }
            }
            resolve(tun)
        }).catch(function(error) {
            if (is_loadding) that.$vux.toast.hide()
            that.$vux.toast.show({
                text: error.message,
                type: 'warn',
                time: '2000'
            })
            reject(tun)
        })
    })
    return promise
}
export function post_file(parames = {}, that, is_loadding = 1, error_msg = 1, success_msg = 1) {
    var promise = new Promise(function(resolve, reject) {
        var tun = ''
        if (parames.multiple) {
            var len = Object.keys(parames.multiple).length
        } else {
            var len = Object.keys(parames).length
        }
        if (len < 1) return ''
        let multiple = false
        var option = {
            type: 'img',
            size: '380_380',
            channel: 'mobile'
        }
        parames = Object.assign(option, parames)
        config.headers = headers2
        config.url = format_url('common/upload/pic_upload')
        let data = new FormData()
        if (!parames.multiple) {
            parames['Filedata'] = parames['file']
            delete parames['file']
        } else {
            parames['Filedata'] = {}
            for (var i in parames['multiple']) {
                parames['Filedata[' + i + ']'] = parames['multiple'][i].file
            }
            multiple = true
            delete parames['multiple']
        }
        for (var i in parames) {
            data.append(i, parames[i])
        }
        if (is_loadding) {
            that.$vux.toast.show({
                text: that._func.loading(that),
                type: 'text',
                time: '200000',
                isShowMask: true
            })
        }
        config.data = data
        axios(config).then(function(res) {
            if (is_loadding) that.$vux.toast.hide()
            res = res.data
            if (res.success) {
                if (multiple) {
                    if (res.list) {
                        tun = res.list
                    } else {
                        tun = -1
                    }
                } else {
                    if (res.data) {
                        tun = res.data
                    } else {
                        tun = -1
                    }
                }
                if (success_msg == 1) {
                    that.$vux.toast.show({
                        text: res.msg,
                        type: 'success',
                    })
                    setTimeout(function() {
                        that.$vux.toast.hide()
                    }, 2000)
                }
            } else {
                if (error_msg == 1) {
                    that.$vux.toast.show({
                        text: res.msg,
                        width: 'auto',
                        type: 'text',
                    })
                    setTimeout(function() {
                        that.$vux.toast.hide()
                    }, 2000)
                }
            }
            resolve(tun)
        }).catch(function(error) {
            if (is_loadding) that.$vux.toast.hide()
            that.$vux.toast.show({
                text: error.message,
                type: 'warn',
                time: '2000'
            })
            reject(tun)
        })
    })
    return promise
}
export function captcha(parames = '') {
    if (!parames) {
        let url = 'common/ajax/get_code?refresh=' + Math.random()
        return format_url(url)
    } else {
        let url = 'common/ajax/auth_code?code=' + parames
        var promise = new Promise(function(resolve, reject) {
            config.url = format_url(url)
            axios(config).then(function(ret) {
                resolve(ret.data)
            }).catch(function(error) {
                reject('')
            })
        })
        return promise
    }
}